// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__bUxMd","box":"styles_box__ZP8wH","icon":"styles_icon__qr4BB"};